import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Categories from './Categories'
import Products from './Products'
import Profile from './Profile'
import AddProduct from './Products/AddProduct'
import EditProduct from './Products/EditProduct'
import EditCategory from './Categories/EditCategory'

const Render = () => {
    return (
        <Routes>
            <Route path='' element={<Categories />} />
            <Route path='products' element={<Products />} />
            <Route path='profile' element={<Profile />} />
            <Route path='addProduct' element={<AddProduct />} />
            <Route path='editProduct' element={<EditProduct />} />
            <Route path='editCategory' element={<EditCategory />} />
            <Route path='*' element={<Navigate to={'/admin'} replace />} />
        </Routes>
    )
}

export default Render